import { SxProps } from '@mui/material'
import {
  GridColDef,
  GridEventListener,
  GridRowSelectionModel,
} from '@mui/x-data-grid'
import { useMemo } from 'react'

import KanseiDataGrid from 'components/copied/dataGrid'
import { helper } from 'helper'
import { ApiSecurityFilterWithDetail } from 'types/security'

interface Props {
  securities: ApiSecurityFilterWithDetail[]
  onChangeChecked: (securityIds: string[]) => void
  onClickSecurity: (security: ApiSecurityFilterWithDetail) => void
}

const columns: GridColDef[] = [
  { field: 'name', headerName: '隊員名', width: 140 },
  { field: 'phone', headerName: '電話番号', flex: 1 },
  { field: 'email', headerName: 'メールアドレス', flex: 1 },
  { field: 'securityField', headerName: '警備先', flex: 1 },
]

export default function SecurityTableComponent(props: Props) {
  const rows = useMemo(() => {
    return props.securities.map((security) => {
      return {
        id: security.id,
        name: helper.formatter.nameFormat(security),
        phone: security.cls2Detail.phoneNumber1, // 携帯電話
        email: security.cls2Detail.email,
        securityField: security.securityFields.map((v) => v.name).join('、'),
      }
    })
  }, [props.securities])

  const handleCellClick: GridEventListener<'cellClick'> = (params, event) => {
    const isCheckbox = params.field === '__check__'
    if (!isCheckbox) {
      // チェックボックスをトグルさせない
      event.stopPropagation()

      const security = props.securities.find((x) => x.id === params.id)
      if (security != null) props.onClickSecurity(security)
      return
    }
  }

  const handleChange = (e: GridRowSelectionModel) => {
    const securityIds = e.map((x) => x.toString())
    props.onChangeChecked(securityIds)
  }

  return (
    <>
      <KanseiDataGrid
        checkboxSelection={true}
        rows={rows as []}
        columns={columns}
        onCellClick={handleCellClick}
        handleChange={handleChange}
        sx={gridStyle}
        showMenu={true}
      />
    </>
  )
}

const gridStyle: SxProps = {
  padding: 0,
  // メモ
  // なぜかdata-gridのスクロールが効いてない
  // 一旦、上から強制的にスタイルを書き換えてスクロールしている
  '& .MuiDataGrid-virtualScroller': {
    overflowY: 'scroll',
  },
}
